import { WarningType } from 'entities/SiteB2B/types/LogsType'

const sendLog = (data: string) => {
  const request = new Request(
    (window.NextUrl || import.meta.env.VITE_NEXT_PUBLIC_API) +
      '/api/ui/common/tolog',
    {
      method: 'POST',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json'
      },
      body: data
    }
  )
  fetch(request)
}

const Warnings = (text: string) => {
  return (
    (['window.dataLayer is undefined'].some((m) => text.includes(m)) &&
      WarningType.Warning) ||
    null
  )
}

const Errors = (text: string) => {
  return (
    (['error'].some((m) => text.toLocaleLowerCase().includes(m)) &&
      WarningType.Error) ||
    null
  )
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function globalError(e: any) {
  e.preventDefault()
  // eslint-disable-next-line no-nested-ternary
  const error = e.error ? e.error : e.reason ? e.reason : e
  const data = JSON.stringify({
    Error: error.message
      ? {
          message: error.message,
          stack: error.stack,
          fromCatch: '/index globalError '
        }
      : { ...error, fromCatch: '/index globalError' },
    Type:
      Warnings(error.message) ||
      (e.type && Errors(e.type)) ||
      WarningType.Warning
  })
  sendLog(data)
  return true
}
